import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	border-top: 1px solid ${colors.grey2};

	&:first-child {
		border-top: none;
	}
`;

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	font-weight: 400;
	font-size: 13px;
	line-height: 20px;
	padding: 8px 8px 8px 34px;
`;
